(function(){
  var ICON_MUTED = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 9v6h4l5 5V4L8 9H4z" fill="#fff"/><line x1="16" y1="9" x2="22" y2="15" stroke="#fff" stroke-width="2" stroke-linecap="round"/><line x1="22" y1="9" x2="16" y2="15" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_UNMUTED = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 9v6h4l5 5V4L8 9H4z" fill="#fff"/><path d="M16 8a5 5 0 0 1 0 8" stroke="#fff" stroke-width="2" stroke-linecap="round" fill="none"/><path d="M18.5 5.5a9 9 0 0 1 0 13" stroke="#fff" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';

  function isMobile(){
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function buildVideo(src, opts){
    opts = opts || {};
    var v = document.createElement('video');
    v.className = 'cbv-video';
    v.src = src;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    if(opts.loop){ v.loop = true; v.setAttribute('loop', ''); }
    if(opts.muted){ v.muted = true; v.setAttribute('muted', ''); }
    return v;
  }

  function openLightbox(src){
    var box = document.createElement('div');
    box.className = 'cbv-lightbox';

    var video = buildVideo(src, { loop: false, muted: false });
    video.controls = true;
    video.autoplay = true;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cbv-lightbox__close';
    close.setAttribute('aria-label', 'Close video');
    close.innerHTML = '&times;';

    function destroy(){
      video.pause();
      box.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e){
      if(e.key === 'Escape') destroy();
    }

    close.addEventListener('click', destroy);
    box.addEventListener('click', function(e){
      if(e.target === box) destroy();
    });
    document.addEventListener('keydown', onKey);

    box.appendChild(video);
    box.appendChild(close);
    document.body.appendChild(box);

    video.play().catch(function(){});
  }

  document.querySelectorAll('[data-cbv-media]').forEach(function(media){
    var videoUrl = media.getAttribute('data-video-url');
    var toggle = media.querySelector('[data-cbv-play]');
    if(!videoUrl) return;

    var previewVideo = null;
    var started = false;

    function startPreview(){
      if(started) return;
      started = true;

      previewVideo = buildVideo(videoUrl, { loop: true, muted: true });
      media.appendChild(previewVideo);
      media.classList.add('is-playing');
      previewVideo.play().catch(function(){});

      if(toggle && !isMobile()){
        toggle.setAttribute('aria-label', 'Unmute video');
        toggle.innerHTML = ICON_MUTED;
      }
    }

    media.addEventListener('click', function(){
      if(isMobile()) openLightbox(videoUrl);
    });

    if(toggle){
      toggle.addEventListener('click', function(e){
        e.stopPropagation();
        if(isMobile() || !previewVideo) return;
        previewVideo.muted = !previewVideo.muted;
        toggle.setAttribute('aria-label', previewVideo.muted ? 'Unmute video' : 'Mute video');
        toggle.innerHTML = previewVideo.muted ? ICON_MUTED : ICON_UNMUTED;
      });
    }

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting) startPreview();
        });
      }, { threshold: 0.5 });

      io.observe(media);
    } else {
      startPreview();
    }
  });
})();
